import { ItCheckboxBase } from './it-checkbox-base.js';
import '../index-BsUQkm6O.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/if-defined.js';
import 'lit/directives/when.js';
import 'lit/directives/live.js';

/**
 * @element it-checkbox
 */
class ItCheckbox extends ItCheckboxBase {
}
if (!customElements.get('it-checkbox')) {
    customElements.define('it-checkbox', ItCheckbox);
}

export { ItCheckbox };
//# sourceMappingURL=it-checkbox.js.map
